// @core/api/endpoints/billing/update_billing_product.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateBillingProductRequest,
  UpdateBillingProductResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Update product
 * Updates a product's metadata such as name and description. Existing subscriptions using this product are not affected.
 */
export async function UpdateBillingProduct(
  id: string,
  data: UpdateBillingProductRequest,
  options?: RequestOptions
): Promise<UpdateBillingProductResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/products/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.patch<UpdateBillingProductResponse>(requestPath, data, requestOptions);
}
